
<template>
  <v-expansion-panels
    :value="extendless ? 1 : 0"
    :readonly="readonly"
  >
    <v-expansion-panel>
      <v-expansion-panel-header>
        <v-input
          :error="error"
          :error-messages="errorMessages"
          hide-details="auto"
        >
          <slot name="header">
            <b>{{ title }}</b>
          </slot>
        </v-input>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <slot />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: 'BLayoutExpansion',
  props: {
    title: String,
    error: Boolean,
    errorMessages: [String, Array],
    extendless: Boolean,
    readonly: Boolean,
  },
}
</script>
